import { render, staticRenderFns } from "./NewSamplePage.vue?vue&type=template&id=38fc3b5a&scoped=true&"
import script from "./NewSamplePage.vue?vue&type=script&lang=js&"
export * from "./NewSamplePage.vue?vue&type=script&lang=js&"
import style0 from "./NewSamplePage.vue?vue&type=style&index=0&id=38fc3b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc3b5a",
  null
  
)

export default component.exports